import { Person } from './types';

export default function getPersonDisplayName(patient?: Person) {
  if (!patient) {
    return '';
  }
  return [
    patient.frontName,
    patient.firstName,
    patient.lastName,
  ].join(' ');
}
